'use client';

import React from 'react';

const terms = [
  { arabic: 'آيات', english: 'Ayat — Signs & Proofs' },
  { arabic: '✦', english: '' },
  { arabic: 'تقوى', english: 'Taqwah — God-Consciousness' },
  { arabic: '✦', english: '' },
  { arabic: 'حال', english: 'Haal — State of Being' },
  { arabic: '✦', english: '' },
  { arabic: 'كلي', english: 'Kulli — Universal, Total' },
  { arabic: '✦', english: '' },
  { arabic: 'أمة', english: 'Ummah — Community' },
  { arabic: '✦', english: '' },
  { arabic: 'في سبيل الله', english: 'Fisabilillah — In the Way of Allah' },
  { arabic: '✦', english: '' },
  { arabic: 'باطن', english: 'Batin — Inner Reality' },
  { arabic: '✦', english: '' },
];

export default function MarqueeSection() {
  return (
    <div
      className="overflow-hidden relative py-5"
      style={{
        backgroundColor: '#2C4A3E',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      {/* Left fade */}
      <div
        className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(90deg, #2C4A3E, transparent)' }}
      />
      {/* Right fade */}
      <div
        className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(270deg, #2C4A3E, transparent)' }}
      />
      <div className="marquee-track">
        {[...terms, ...terms]?.map((term, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-3 mx-6"
          >
            {term?.arabic === '✦' ? (
              <span style={{ color: 'rgba(179,138,42,0.4)', fontSize: 12 }}>✦</span>
            ) : (
              <>
                <span
                  className="font-heading text-lg"
                  style={{ color: 'rgba(255,255,255,0.8)', fontStyle: 'italic' }}
                >
                  {term?.arabic}
                </span>
                {term?.english && (
                  <span
                    className="font-mono text-xs tracking-wider"
                    style={{ color: 'rgba(179,138,42,0.7)', fontFamily: 'var(--font-mono)', whiteSpace: 'nowrap' }}
                  >
                    {term?.english}
                  </span>
                )}
              </>
            )}
          </span>
        ))}
      </div>
    </div>
  );
}